import { PrimaryCta } from '#components/cta/PrimaryCta';
import { env } from '#env/client.mjs';
import { isWalletAddress } from '@packages/common-ui/types/wallet';
import { chainIdToName } from '@packages/common-ui/constants';
import { useWallet } from '@packages/common-ui/hooks/useWallet';
import { useSwitchNetwork } from 'wagmi';
export const WrongChain = () => {
  const targetChainId = Number(env.NEXT_PUBLIC_TARGET_CHAIN_ID);
  const targetChainName = chainIdToName.get(targetChainId) ?? 'unknown chain';
  const {
    switchNetwork,
    error,
    isLoading
  } = useSwitchNetwork();
  const {
    walletAddress
  } = useWallet();
  return <section className="absolute top-1/2 flex min-h-screen w-full -translate-y-1/2 flex-col items-center justify-center bg-generic bg-cover bg-center">
      <h2 className="text-6xl uppercase">Invalid Chain ID</h2>
      <p className="text-center font-chakra-petch text-sm">Please connect to {targetChainName}</p>
      {isWalletAddress(walletAddress) && <PrimaryCta containerClassName="mt-5" onClick={() => switchNetwork?.(targetChainId)} disabled={isLoading}>
          Switch to {targetChainName}
        </PrimaryCta>}
      {error && <p className="pt-3 font-chakra-petch text-base text-white/80">
          Oops, Something went wrong
        </p>}
    </section>;
};